import {
    ProjectCheckpointsList,
    TasksModel,
} from '../../../domain/projectCheckpoints/projectCheckpointList';
import {
    ProjectCheckpointsListDTO,
    TasksModelDTO,
} from '../../http/dtos/projectCheckpoints/projectCheckpointListDTO';

const getProjectCheckpointsListAdapter = (
    responseAPI: ProjectCheckpointsListDTO[]
): ProjectCheckpointsList[] => {
    return responseAPI
        ? responseAPI.map((projectCheckpoints) => {
              return {
                  id: projectCheckpoints.id,
                  projectName: projectCheckpoints.projectName,
                  employeeName: projectCheckpoints.employeeName,
                  comments: projectCheckpoints.comments,
                  date: projectCheckpoints.date,
                  tasks: projectCheckpoints.tasks,
              };
          })
        : [];
};

const getTasksProjectCheckpointsAdapter = (
    responseAPI: TasksModelDTO
): TasksModel => {
    return {
        id: responseAPI.id,
        status: responseAPI.status,
        task: responseAPI.task,
        statusDescription: responseAPI.statusDescription,
        comments: responseAPI.comments,
        employeeId: responseAPI.employeeId,
        consultant: responseAPI.consultant,
        estimatedDate: responseAPI.estimatedDate,
    };
};

export const ProjectCheckpointsAdapter = {
    getProjectCheckpointsListAdapter,
    getTasksProjectCheckpointsAdapter,
};
